export default __webpack_public_path__ + "68afcd9f8e6a4bb44a0a2e7bab66057d.png";